import { jsx as _jsx } from "react/jsx-runtime";
import { useEnvironmentContext } from "../../../../../components/providers/Environment/index.js";
import styled from "../../../../../client-utils/styled/index.js";
import { DOUBLE } from "../../../../../constants/numbers.consts.js";
import { coreComponentName } from "../../AppBar.consts.js";
import ButtonBase from "../../../../../components/atoms/ButtonBase/index.js";
import ImageGuard from "../../../../../components/atoms/ImageGuard/index.js";
import Link from "../../../../../components/atoms/Link/index.js";
const Logo = styled(ButtonBase, {
    name: coreComponentName,
    slot: "Logo",
})(({ theme }) => ({
    height: "100%",
    display: "grid",
    placeItems: "center",
    paddingX: theme.spacing(DOUBLE),
    [`${theme.breakpoints.down("expanded")}`]: {
        display: "none",
    },
}));
export const AppBarLogoComponent = ({ src, imageProps, height = 40, translations = {
    title: "Product logo",
    alt: "Product logo",
}, ...props }) => {
    const imageTranslations = {
        title: translations?.title ?? "Product logo",
        alt: translations?.alt ?? "Product logo",
    };
    const { routePaths } = useEnvironmentContext();
    if (!src?.trim()) {
        return null;
    }
    return (_jsx(Logo, { "data-testid": "AppBarLogo", ...props, component: Link, href: routePaths?.root ?? "/", children: _jsx(ImageGuard, { "data-testid": "AppBarLogoImage", ...imageProps, src: src, title: imageTranslations.title, alt: imageTranslations.alt, height: height }) }));
};
export default AppBarLogoComponent;
